import { render, staticRenderFns } from "./SimpleLoader.vue?vue&type=template&id=636af4d1&scoped=true&"
import script from "./SimpleLoader.vue?vue&type=script&lang=ts&"
export * from "./SimpleLoader.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleLoader.vue?vue&type=style&index=0&id=636af4d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636af4d1",
  null
  
)

export default component.exports